import { Component, ViewContainerRef, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';

import { DxTextBoxComponent } from 'devextreme-angular/ui/text-box';

@Component({
    selector: 'phone-input',
    template: require('./devextreme-phone-input.component.html'),
    providers: [],
    styles: [`
        /deep/ .dx-dropdownlist-popup-wrapper .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item-content {
            padding-left: 7px;
            padding-right: 7px;
        }
        /deep/ .custom-item {
            position: relative;
            min-height: 30px;
        }
        /deep/ .custom-item .product-name  {
            display: inline-block;
            padding-left: 10px;
            text-indent: 0;
            line-height: 30px;
            font-size: 12px;
            border: 0;
        }
        /deep/ .custom-item > img {
            left: 5px;
            position: absolute;
            //top: 50%;
            margin-top: 6px;
            height: 20px;
        }
        /deep/ .custom-item-dropdown .product-name-dropdown  {
            display: inline-block;
            padding-left: 5px;
            text-indent: 0;
            line-height: 1em;
            font-size: 12px;
        }
        /deep/ .custom-item-dropdown > img {
            left: 3px;
            position: absolute;
            // top: 50%;
            // margin-top: -15px;
            height: 15px;
        }
        /deep/ .custom-item .dx-texteditor-buttons-container {
            display: none;
        }
        /deep/ .current-value {
            padding: 10px 0;
        }
        /deep/ .current-value > span {
            font-weight: bold;
        }
    `]
})

export class PhoneInputComponent implements OnInit {

    @Input() locale = 'ru';
    @Input() phone: string;
    @Input() isLegacy: boolean;
    @Input() phoneCountryCode = '1';

    @Input() isRequired = true;

    @Input() disabled = false;

    public maskFixedPart = '(000)-000-0000';
    public phoneMaskValue: string;

    phonePattern: any = /^([0-9])*$/;

    @Output() phoneCountryCodeOnValueChangedEmit = new EventEmitter<any>();
    @Output() phoneOnValueChangedEmit = new EventEmitter<any>();

    public countries: Country[] = [
        new Country('1', 'Canada/USA (+1)', 'content/images/flags/canada-usa.png'),
        new Country('93', 'Afghanistan (+93)', null),
        new Country('355', 'Albania (+355)', null),
        new Country('213', 'Algeria (+213)', null),
        new Country('1', 'American Samoa (+1)', null),
        new Country('376', 'Andorra (+376)', null),
        new Country('244', 'Angola (+244)', null),
        new Country('1', 'Anguilla (+1)', null),
        new Country('1', 'Antigua (+1)', null),
        new Country('54', 'Argentina (+54)', null),
        new Country('374', 'Armenia (+374)', null),
        new Country('297', 'Aruba (+297)', null),
        new Country('61', 'Australia (+61)', null),
        new Country('43', 'Austria (+43)', null),
        new Country('994', 'Azerbaijan (+994)', null),
        new Country('973', 'Bahrain (+973)', null),
        new Country('880', 'Bangladesh (+880)', null),
        new Country('1', 'Barbados (+1)', null),
        new Country('375', 'Belarus (+375)', null),
        new Country('32', 'Belgium (+32)', null),
        new Country('501', 'Belize (+501)', null),
        new Country('229', 'Benin (+229)', null),
        new Country('1', 'Bermuda (+1)', null),
        new Country('975', 'Bhutan (+975)', null),
        new Country('591', 'Bolivia (+591)', null),
        new Country('387', 'Bosnia and Herzegovina (+387)', null),
        new Country('267', 'Botswana (+267)', null),
        new Country('55', 'Brazil (+55)', null),
        new Country('246', 'British Indian Ocean Territory (+246)', null),
        new Country('1', 'British Virgin Islands (+1)', null),
        new Country('673', 'Brunei (+673)', null),
        new Country('359', 'Bulgaria (+359)', null),
        new Country('226', 'Burkina Faso (+226)', null),
        new Country('95', 'Burma Myanmar (+95)', null),
        new Country('257', 'Burundi (+257)', null),
        new Country('855', 'Cambodia (+855)', null),
        new Country('237', 'Cameroon (+237)', null),
        new Country('1', 'Canada (+1)', null),
        new Country('238', 'Cape Verde (+238)', null),
        new Country('1', 'Cayman Islands (+1)', null),
        new Country('236', 'Central African Republic (+236)', null),
        new Country('235', 'Chad (+235)', null),
        new Country('56', 'Chile (+56)', null),
        new Country('86', 'China (+86)', null),
        new Country('57', 'Colombia (+57)', null),
        new Country('269', 'Comoros (+269)', null),
        new Country('682', 'Cook Islands (+682)', null),
        new Country('506', 'Costa Rica (+506)', null),
        new Country('225', 'Côte d-Ivoire (+225)', null),
        new Country('385', 'Croatia (+385)', null),
        new Country('53', 'Cuba (+53)', null),
        new Country('357', 'Cyprus (+357)', null),
        new Country('420', 'Czech Republic (+420)', null),
        new Country('243', 'Democratic Republic of Congo (+243)', null),
        new Country('45', 'Denmark (+45)', null),
        new Country('253', 'Djibouti (+253)', null),
        new Country('1', 'Dominica (+1)', null),
        new Country('1', 'Dominican Republic (+1)', null),
        new Country('593', 'Ecuador (+593)', null),
        new Country('20', 'Egypt (+20)', null),
        new Country('503', 'El Salvador (+503)', null),
        new Country('240', 'Equatorial Guinea (+240)', null),
        new Country('291', 'Eritrea (+291)', null),
        new Country('372', 'Estonia (+372)', null),
        new Country('251', 'Ethiopia (+251)', null),
        new Country('500', 'Falkland Islands (+500)', null),
        new Country('298', 'Faroe Islands (+298)', null),
        new Country('691', 'Federated States of Micronesia (+691)', null),
        new Country('679', 'Fiji (+679)', null),
        new Country('358', 'Finland (+358)', null),
        new Country('33', 'France (+33)', null),
        new Country('594', 'French Guiana (+594)', null),
        new Country('689', 'French Polynesia (+689)', null),
        new Country('241', 'Gabon (+241)', null),
        new Country('995', 'Georgia (+995)', null),
        new Country('49', 'Germany (+49)', null),
        new Country('233', 'Ghana (+233)', null),
        new Country('350', 'Gibraltar (+350)', null),
        new Country('30', 'Greece (+30)', null),
        new Country('299', 'Greenland (+299)', null),
        new Country('1', 'Grenada (+1)', null),
        new Country('590', 'Guadeloupe (+590)', null),
        new Country('1', 'Guam (+1)', null),
        new Country('502', 'Guatemala (+502)', null),
        new Country('224', 'Guinea (+224)', null),
        new Country('245', 'Guinea-Bissau (+245)', null),
        new Country('592', 'Guyana (+592)', null),
        new Country('509', 'Haiti (+509)', null),
        new Country('504', 'Honduras (+504)', null),
        new Country('852', 'Hong Kong (+852)', null),
        new Country('36', 'Hungary (+36)', null),
        new Country('354', 'Iceland (+354)', null),
        new Country('91', 'India (+91)', null),
        new Country('62', 'Indonesia (+62)', null),
        new Country('98', 'Iran (+98)', null),
        new Country('964', 'Iraq (+964)', null),
        new Country('353', 'Ireland (+353)', null),
        new Country('972', 'Israel (+972)', null),
        new Country('39', 'Italy (+39)', null),
        new Country('1', 'Jamaica (+1)', null),
        new Country('81', 'Japan (+81)', null),
        new Country('962', 'Jordan (+962)', null),
        new Country('254', 'Kenya (+254)', null),
        new Country('686', 'Kiribati (+686)', null),
        new Country('381', 'Kosovo (+381)', null),
        new Country('965', 'Kuwait (+965)', null),
        new Country('996', 'Kyrgyzstan (+996)', null),
        new Country('856', 'Laos (+856)', null),
        new Country('371', 'Latvia (+371)', null),
        new Country('961', 'Lebanon (+961)', null),
        new Country('266', 'Lesotho (+266)', null),
        new Country('231', 'Liberia (+231)', null),
        new Country('218', 'Libya (+218)', null),
        new Country('423', 'Liechtenstein (+423)', null),
        new Country('370', 'Lithuania (+370)', null),
        new Country('352', 'Luxembourg (+352)', null),
        new Country('853', 'Macau (+853)', null),
        new Country('389', 'Macedonia (+389)', null),
        new Country('261', 'Madagascar (+261)', null),
        new Country('265', 'Malawi (+265)', null),
        new Country('60', 'Malaysia (+60)', null),
        new Country('960', 'Maldives (+960)', null),
        new Country('223', 'Mali (+223)', null),
        new Country('356', 'Malta (+356)', null),
        new Country('692', 'Marshall Islands (+692)', null),
        new Country('596', 'Martinique (+596)', null),
        new Country('222', 'Mauritania (+222)', null),
        new Country('230', 'Mauritius (+230)', null),
        new Country('262', 'Mayotte (+262)', null),
        new Country('52', 'Mexico (+52)', null),
        new Country('373', 'Moldova (+373)', null),
        new Country('377', 'Monaco (+377)', null),
        new Country('976', 'Mongolia (+976)', null),
        new Country('382', 'Montenegro (+382)', null),
        new Country('1', 'Montserrat (+1)', null),
        new Country('212', 'Morocco (+212)', null),
        new Country('258', 'Mozambique (+258)', null),
        new Country('264', 'Namibia (+264)', null),
        new Country('674', 'Nauru (+674)', null),
        new Country('977', 'Nepal (+977)', null),
        new Country('31', 'Netherlands (+31)', null),
        new Country('599', 'Netherlands Antilles (+599)', null),
        new Country('687', 'New Caledonia (+687)', null),
        new Country('64', 'New Zealand (+64)', null),
        new Country('505', 'Nicaragua (+505)', null),
        new Country('227', 'Niger (+227)', null),
        new Country('234', 'Nigeria (+234)', null),
        new Country('683', 'Niue (+683)', null),
        new Country('672', 'Norfolk Island (+672)', null),
        new Country('850', 'North Korea (+850)', null),
        new Country('1', 'Northern Mariana Islands (+1)', null),
        new Country('47', 'Norway (+47)', null),
        new Country('968', 'Oman (+968)', null),
        new Country('92', 'Pakistan (+92)', null),
        new Country('680', 'Palau (+680)', null),
        new Country('970', 'Palestine (+970)', null),
        new Country('507', 'Panama (+507)', null),
        new Country('675', 'Papua New Guinea (+675)', null),
        new Country('595', 'Paraguay (+595)', null),
        new Country('51', 'Peru (+51)', null),
        new Country('63', 'Philippines (+63)', null),
        new Country('48', 'Poland (+48)', null),
        new Country('351', 'Portugal (+351)', null),
        new Country('1', 'Puerto Rico (+1)', null),
        new Country('974', 'Qatar (+974)', null),
        new Country('242', 'Republic of the Congo (+242)', null),
        new Country('262', 'Réunion (+262)', null),
        new Country('40', 'Romania (+40)', null),
        new Country('7', 'Russia (+7)', null),
        new Country('250', 'Rwanda (+250)', null),
        new Country('590', 'Saint Barthélemy (+590)', null),
        new Country('290', 'Saint Helena (+290)', null),
        new Country('1', 'Saint Kitts and Nevis (+1)', null),
        new Country('590', 'Saint Martin (+590)', null),
        new Country('508', 'Saint Pierre and Miquelon (+508)', null),
        new Country('1', 'Saint Vincent and the Grenadines (+1)', null),
        new Country('685', 'Samoa (+685)', null),
        new Country('378', 'San Marino (+378)', null),
        new Country('239', 'São Tomé and Príncipe (+239)', null),
        new Country('966', 'Saudi Arabia (+966)', null),
        new Country('221', 'Senegal (+221)', null),
        new Country('381', 'Serbia (+381)', null),
        new Country('248', 'Seychelles (+248)', null),
        new Country('232', 'Sierra Leone (+232)', null),
        new Country('65', 'Singapore (+65)', null),
        new Country('421', 'Slovakia (+421)', null),
        new Country('386', 'Slovenia (+386)', null),
        new Country('677', 'Solomon Islands (+677)', null),
        new Country('252', 'Somalia (+252)', null),
        new Country('27', 'South Africa (+27)', null),
        new Country('82', 'South Korea (+82)', null),
        new Country('34', 'Spain (+34)', null),
        new Country('94', 'Sri Lanka (+94)', null),
        new Country('1', 'St. Lucia (+1)', null),
        new Country('249', 'Sudan (+249)', null),
        new Country('597', 'Suriname (+597)', null),
        new Country('268', 'Swaziland (+268)', null),
        new Country('46', 'Sweden (+46)', null),
        new Country('41', 'Switzerland (+41)', null),
        new Country('963', 'Syria (+963)', null),
        new Country('886', 'Taiwan (+886)', null),
        new Country('992', 'Tajikistan (+992)', null),
        new Country('255', 'Tanzania (+255)', null),
        new Country('66', 'Thailand (+66)', null),
        new Country('1', 'The Bahamas (+1)', null),
        new Country('220', 'The Gambia (+220)', null),
        new Country('670', 'Timor-Leste (+670)', null),
        new Country('228', 'Togo (+228)', null),
        new Country('690', 'Tokelau (+690)', null),
        new Country('676', 'Tonga (+676)', null),
        new Country('1', 'Trinidad and Tobago (+1)', null),
        new Country('216', 'Tunisia (+216)', null),
        new Country('90', 'Turkey (+90)', null),
        new Country('993', 'Turkmenistan (+993)', null),
        new Country('1', 'Turks and Caicos Islands (+1)', null),
        new Country('688', 'Tuvalu (+688)', null),
        new Country('256', 'Uganda (+256)', null),
        new Country('380', 'Ukraine (+380)', null),
        new Country('971', 'United Arab Emirates (+971)', null),
        new Country('44', 'United Kingdom (+44)', null),
        new Country('1', 'United States (+1)', null),
        new Country('598', 'Uruguay (+598)', null),
        new Country('1', 'US Virgin Islands (+1)', null),
        new Country('998', 'Uzbekistan (+998)', null),
        new Country('678', 'Vanuatu (+678)', null),
        new Country('39', 'Vatican City (+39)', null),
        new Country('58', 'Venezuela (+58)', null),
        new Country('84', 'Vietnam (+84)', null),
        new Country('681', 'Wallis and Futuna (+681)', null),
        new Country('967', 'Yemen (+967)', null),
        new Country('260', 'Zambia (+260)', null),
        new Country('263', 'Zimbabwe (+263)', null),
        new Country(null, '', null)
    ];

    @ViewChild('phoneInput', { static: false }) public phoneInput: DxTextBoxComponent;

    constructor(
        public vcRef: ViewContainerRef,
        private elementRef: ElementRef) {
        this.phoneMaskValue = `+1 ${this.maskFixedPart}`;
    }

    ngOnInit(): void {
    }

    getMaskByCountry(value: any): string {
        return this.maskFixedPart;
    }

    //Obsolete
    //used for mask input
    onValueChanged(event: any) {
        //do nothing
    }

    phoneOnKeyUp(event: any) {
        event.stopPropagation();
    }

    trimPhoneInput(event: any) {
        if (event != null && event.value != null) {
            const trimmed = event.value.replace(/\s+/g, '').trim();
            this.phoneInput.value = trimmed;
        }
    }

    phoneCountryCodeOnValueChanged(event: any) {
        this.phoneCountryCodeOnValueChangedEmit.emit(event.value);
    }

    phoneOnValueChanged(event: any) {
        this.trimPhoneInput(event);
        this.phoneOnValueChangedEmit.emit(this.phoneInput.value);
    }
}

export class Country {
    id: string;
    name: string;
    imageSrc: string;

    public getDisplayName(): string {
        if (this.id == null) {
            return null;
        }
        return this.name + ' (+' + this.id + ')';
    }

    constructor(id: string, name: string, imageSrc: string) {
        this.id = id;
        this.name = name;
        this.imageSrc = imageSrc;
    }
}



// WEBPACK FOOTER //
// ./src/custom_modules/devextreme-phone-input/devextreme-phone-input.component.ts